import { createFileRoute, useRouter } from "@tanstack/react-router";
import visualImgSrc from "$/login/visual_customer.svg";
import visualBusinessImgSrc from "$/login/visual_business.svg";
import { Button } from "@/Button";
import {
  MouseEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
// import { Input } from "../components/Input";
// import { ThemedButton } from "../components/Button";
// import { useMutation } from "@tanstack/react-query";
import { businessLogin, userLogin } from "../api/services/auth";
// import { LoginResponse } from "../api/types/common";
import appleImgSrc from "$/login/apple.png";
import googleImgSrc from "$/login/google.svg";
import kakaoImgSrc from "$/login/kakao.svg";
import naverImgSrc from "$/login/naver.svg";
import { motion, AnimatePresence } from "framer-motion";
import { AppType, SignType } from "#/unique/domain";
import { useStorage } from "^/common/useStorage";
import { href } from "%/location";
import {
  GOOGLE_AUTH_URL,
  NAVER_AUTH_URL,
  KAKAO_AUTH_URL,
  buildAuthUrlWithPrompt,
} from "#/auth/signIn";
import { useToastStore } from "&/toast";
import { usePreload } from "^/common/usePreload";
import { useAppColor } from "^/common/useAppColor";
import { usePlatform } from "^/common/usePlatform";
import { useAppleLogin } from "^/common/useAppleLogin";
// import { useLoadingStore } from "&/loading";
import { SHA256 } from "crypto-js";
import { useCookies } from "react-cookie";
import { unifiedLogin, unifiedLoginAuto } from "../utils/unifiedLogin";
import { useLoginHandlers } from "../utils/loginHandlers";
import { getBusinessAuthUserInfo } from "~/services/business/auth";
import { shouldDeferDefaultNavigationForIntent } from "&/navigationIntent";
// import { publicHttp } from "~/config/axios";

export const Route = createFileRoute("/")({
  component: Home,
});
function Home() {
  const { history } = useRouter();
  const { add } = useToastStore();
  const [type] = useStorage<AppType>("session-app-type");
  const [, setCookie] = useCookies(["email"]);
  const [, setName] = useCookies(["name"]);
  const { handleLoginSuccess, handleLoginFailure } = useLoginHandlers();

  // const [, setBusiness] = useStorage<BusinessType>("local-business-type");
  const [sns, setSns] = useStorage<SignType>("local-sign-sns-type");
  const [sessionSns, setSessionSns] = useStorage<SignType>(
    "session-sign-sns-type",
  );
  const [fcm, setFcm] = useStorage<string>("session-fcm");
  const [, setType] = useStorage<AppType>("session-app-type");
  const params = new URL(document.URL).searchParams;
  const snsType = params.get("sns-type");
  const hash = params.get("hash");
  // const [isReady, setIsReady] = useState(true);
  const [, setSnsId] = useStorage<string>("local-sns-id");
  // const [cookie] = useCookies(["email"]);
  // const email: string = useMemo(() => cookie.email, [cookie]);
  const userAgent = navigator.userAgent;
  // 기존 isIOS/isAndroid: 멍투데이 앱(WebView) 만 감지 (네이티브 브릿지 호출 등에 사용)
  const isIOS = useMemo(() => {
    return /MT_I/i.test(userAgent);
  }, [userAgent]);
  const isAndroid = useMemo(() => {
    return /MT_A/i.test(userAgent);
  }, [userAgent]);
  // 신규: PC·모바일웹·앱 5종 환경 통합 감지 (UI 분기에 사용)
  const { isAppIOS, isAppAndroid } = usePlatform();
  // 웹 전용 애플 로그인 (앱은 아래 MT_I/MT_A 분기에서 네이티브가 처리)
  const { loginWithApple } = useAppleLogin();
  console.log("===========================hash", hash);
  // 자동로그인 처리
  const handleAutoLogin = useCallback(async () => {
    // URL 파라미터 우선 사용, 없으면 session storage 사용
    const currentSns = (snsType as SignType) || sns;
    const currentHash = hash;

    if (!currentSns || !currentHash) {
      console.warn("자동로그인에 필요한 데이터가 없습니다:", {
        snsType,
        sns,
        hash,
        currentSns,
        currentHash,
      });
      return;
    }

    console.log("자동로그인 시작1:", { currentSns, currentHash, fcm, isIOS });

    try {
      const result = await unifiedLogin({
        userType: import.meta.env.VITE_APP_TYPE as AppType,
        snsType: currentSns,
        hash: currentHash,
        fcmToken: fcm,
        cdMobileType: isIOS ? "IOS" : "ANDROID",
      });

      console.log("자동로그인 결과2:", result);

      if (result.success) {
        setSessionSns(currentSns);
        console.log("자동로그인 성공");
        await handleLoginSuccess(
          import.meta.env.VITE_APP_TYPE as AppType,
          result.data,
          true,
        );
      } else {
        console.error("자동로그인 실패3:", result.error);
        handleLoginFailure(
          import.meta.env.VITE_APP_TYPE as AppType,
          result.statusCode || 500,
          currentSns,
        );
      }
    } catch (error) {
      console.error("자동로그인 처리 중 오류4:", error);
      // setIsReady(true);
    }
  }, [
    snsType,
    sns,
    hash,
    fcm,
    isIOS,
    handleLoginSuccess,
    handleLoginFailure,
    // setIsReady,
  ]);
  const handleAutoLogin2 = useCallback(async () => {
    if (!hash) return;

    console.log("해시값만으로 자동로그인 시도:", { hash });

    try {
      // 기존 SNS 정보가 있으면 사용, 없으면 기본값
      // const currentSns = sessionSns || sns || "SNS_TYPE_KAKAO";

      // hash 만으로 로그인하는 경로도 현재 기기 FCM 토큰을 같이 보내 서버 토큰을 갱신한다.
      const result = await unifiedLoginAuto({
        userType: import.meta.env.VITE_APP_TYPE as AppType,
        hash: hash,
        fcmToken: fcm || undefined,
        cdMobileType: isIOS ? "IOS" : "ANDROID",
      });

      if (result.success) {
        console.log("자동로그인 성공 (해시값만)");
        await handleLoginSuccess(
          import.meta.env.VITE_APP_TYPE as AppType,
          result.data,
          true, // isAutoLogin = true
        );
      }
      // else {
      //   console.log("자동로그인 실패:", result.statusCode);
      //   // 실패 시 적절한 처리 (로그인 페이지로 이동 등)
      //   handleLoginFailure(
      //     import.meta.env.VITE_APP_TYPE as AppType,
      //     result.statusCode || 500,
      //     currentSns
      //   );
      // }
    } catch (error) {
      console.error("자동로그인 처리 중 오류:", error);
      // 에러 시 기본 페이지로
      history.push("/");
    }
  }, [hash, fcm, isIOS, sessionSns, handleLoginSuccess, handleLoginFailure]);

  useEffect(() => {
    // URL에 sns-type과 hash가 모두 있으면 자동로그인 시도\
    console.log("확인용 snsType", snsType);
    console.log("확인용 sns", sns);
    console.log("확인용 hash", hash);
    if (snsType && hash) {
      console.log("URL 파라미터로 자동로그인 시도:7", { snsType, hash });
      handleAutoLogin();
    }
    // session storage에 sns와 hash가 있으면 자동로그인 시도
    else if (sessionSns && hash) {
      console.log("Session storage로 자동로그인 시도:8", { sns, hash });
      handleAutoLogin();
    } else if (hash && !snsType && !sessionSns) {
      handleAutoLogin2();
    }
  }, [snsType, sns, hash, handleAutoLogin, sessionSns]);

  // SNS 로그인 처리
  const handleSnsLogin = useCallback(
    async (data: any) => {
      console.log("=====================1===========================", hash);
      console.log("=====================1===========================", data);
      console.log("=====================1===========================", sns);
      console.log("=====================1===========================", snsType);
      console.log(
        "=====================1===========================",
        sessionSns,
      );
      console.log(
        "=====================1===========================",
        JSON.stringify(data),
      );
      try {
        console.log("SNS 로그인 시작:9", data);

        const loginData = JSON.parse(data).payload;
        const loginFcm = JSON.parse(data)["fcm-token"];

        if (!loginData?.snsId || !loginData?.cdSnsType) {
          console.error("SNS 로그인 데이터가 올바르지 않습니다:", loginData);
          return;
        }

        console.log("SNS 로그인 데이터:10", { loginData, loginFcm });

        // 해시 생성 (앱 연동은 로그인 성공 후에 수행)
        const key = loginData.cdSnsType + loginData.snsId;
        const hash = SHA256(key).toString();

        if (isIOS && !loginData.email) {
          alert("이메일이 없습니다." + loginData.email);
        }

        // 이메일 쿠키 설정
        if (loginData.email) {
          setCookie("email", loginData.email, {
            secure: true,
            maxAge: 3600,
          });
        }
        if (loginData.name) {
          setName("name", loginData.name, {
            secure: true,
            maxAge: 3600,
          });
        }

        // SNS 정보 저장
        setSnsId(loginData.snsId);
        setSns(loginData.cdSnsType as SignType);
        setSessionSns(loginData.cdSnsType as SignType);
        setFcm(loginFcm);

        console.log("통합 로그인 호출 시작:11");

        // 통합 로그인 함수 사용
        const result = await unifiedLogin({
          userType: import.meta.env.VITE_APP_TYPE as AppType,
          snsType: loginData.cdSnsType,
          hash,
          fcmToken: loginFcm,
          cdMobileType: isIOS ? "IOS" : "ANDROID",
          email: loginData.email,
        });

        console.log("통합 로그인 결과:12", result);
        console.log("result.success:", result.success);
        console.log("result.statusCode:", result.statusCode);
        console.log("result.data:", result.data);
        console.log("result.error:", result.error);

        if (result.success) {
          console.log("로그인 성공, 메인 페이지로 이동");
          // ⚠️ 로그인 성공 시에만 appLogin 호출
          if (isAndroid) {
            window.mung.appLogin(hash);
          }
          if (isIOS) {
            const array = ["appLogin", hash];
            window.webkit?.messageHandlers?.mung?.postMessage(array);
          }

          await handleLoginSuccess(
            import.meta.env.VITE_APP_TYPE as AppType,
            result.data,
          );
        } else {
          console.log("로그인 실패, 상태 코드:", result.statusCode);
          console.log("로그인 실패, 에러:", result.error);

          // 회원가입이 필요한 경우 (201) 또는 기타 실패
          handleLoginFailure(
            import.meta.env.VITE_APP_TYPE as AppType,
            result.statusCode || 500,
            loginData.cdSnsType,
          );
        }
      } catch (error) {
        console.error("SNS 로그인 처리 중 오류:", error);
        alert(
          "로그인 처리 중 오류가 발생했습니다: " +
            (error instanceof Error ? error.message : "알 수 없는 오류"),
        );
      }
    },
    [
      isIOS,
      handleLoginSuccess,
      handleLoginFailure,
      setCookie,
      setSnsId,
      setSns,
      setFcm,
    ],
  );

  // window.callAppLogin 함수를 컴포넌트 마운트 시 오버라이드
  useEffect(() => {
    if (isIOS || isAndroid) {
      // window.callAppLogin 함수 오버라이드 - 로그인 완료 후 메인 페이지로 이동
      window.callAppLogin = async (data: string) => {
        console.log("앱에서 callAppLogin 호출됨:", data);
        setFcm(data);

        if (shouldDeferDefaultNavigationForIntent()) {
          console.log("pending 딥링크 우선 처리로 callAppLogin 기본 이동 보류");
          return;
        }

        // 앱에서 로그인 완료 신호를 받았으므로 메인 페이지로 이동
        try {
          const userType = import.meta.env.VITE_APP_TYPE as AppType;

          if (userType === "business") {
            // 비즈니스 사용자 권한에 따른 리다이렉트
            const businessUserInfo = await getBusinessAuthUserInfo();

            if (businessUserInfo.isOwner) {
              history.push("/business/layout/home");
            } else if (
              businessUserInfo.isTeacher &&
              businessUserInfo.assignedCompany
            ) {
              history.push("/business/layout/home");
            } else {
              history.push("/business/layout/teacher");
            }
          } else {
            // 일반 고객
            history.push("/customer/layout/home");
          }
        } catch (error) {
          console.error("callAppLogin 처리 중 오류:", error);
          // 에러 발생 시 기본 페이지로
          history.push("/");
        }
      };

      // window.fnHistoryBack 함수는 Nav.tsx에서 오버라이드되므로 여기서는 정의하지 않음
      // Nav.tsx가 더 늦게 마운트되어 최종적으로 오버라이드됨
    }
  }, [isIOS, isAndroid, setFcm, history]);

  const [imgClickCount, setImgClickCount] = useState(0);
  const imgClickTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const showDevButtons = imgClickCount >= 10;

  const handleImgClick = useCallback(() => {
    setImgClickCount((prev) => {
      const next = prev + 1;
      if (imgClickTimer.current) clearTimeout(imgClickTimer.current);
      imgClickTimer.current = setTimeout(() => setImgClickCount(0), 3000);
      return next;
    });
  }, []);

  // 더미 계정 로그인 (로컬 테스트용)
  const handleDummyLogin = useCallback(
    async (snsId: string, cdSnsType: string) => {
      try {
        const userType = import.meta.env.VITE_APP_TYPE as AppType;
        const response = await (import.meta.env.VITE_APP_TYPE === "business"
          ? businessLogin({ snsId, cdSnsType })
          : userLogin({ snsId, cdSnsType }));

        if (response?.statusCode === 200) {
          await handleLoginSuccess(userType, response);
        } else {
          handleLoginFailure(userType, response?.statusCode || 500, cdSnsType);
        }
      } catch (error) {
        console.error("더미 로그인 오류:", error);
      }
    },
    [handleLoginSuccess, handleLoginFailure],
  );

  useEffect(() => {
    setType(import.meta.env.VITE_APP_TYPE as AppType);
    if (isIOS || isAndroid) {
      // window.fnHistoryBack은 Nav.tsx에서 오버라이드되므로 여기서는 정의하지 않음
      window.onNativeLogin = (data: any) => {
        // 비동기 함수를 안전하게 호출
        // if (isIOS) {
        //   alert(JSON.stringify(data));
        // }
        handleSnsLogin(data).catch((error) => {
          console.error("앱 로그인 처리 중 오류:", error);
          alert("로그인 처리 중 오류가 발생했습니다: " + error.message);
        });
      };
    }
    // URL에 sns-type 파라미터가 있을 때만 설정
    if (snsType) {
      setSns(snsType as SignType);
    }
    // if (!hash) {
    //   setIsReady(true);
    // }
  }, [setType, setSns, snsType, handleSnsLogin, isIOS, isAndroid]);

  const visualImg = useMemo(() => {
    switch (type) {
      default:
      case "customer":
        return visualImgSrc;
      case "business":
        return visualBusinessImgSrc;
    }
  }, [type]);

  const handleGoSignUp = useCallback(
    ({ target }: MouseEvent) => {
      if (!(target instanceof HTMLElement) || !target.dataset.snsType) return;
      const snsType = target.dataset.snsType;
      const array = ["nativeLogin"];
      // ───────────────────────────────────────────────────────────
      console.log("[LOGIN-CLICK]", {
        snsType,
        env: isAndroid ? "app-android(MT_A)" : isIOS ? "app-ios(MT_I)" : "web",
        userAgent: navigator.userAgent,
        VITE_KAKAO_KEY: import.meta.env.VITE_KAKAO_KEY ? "✓" : "✗ MISSING",
        VITE_GOOGLE_KEY: import.meta.env.VITE_GOOGLE_KEY ? "✓" : "✗ MISSING",
        VITE_NAVER_KEY: import.meta.env.VITE_NAVER_KEY ? "✓" : "✗ MISSING",
        VITE_APPLE_KEY: import.meta.env.VITE_APPLE_KEY ? "✓" : "✗ MISSING (signIn.ts에서 사용중)",
        VITE_APPLE_CLIENTID: import.meta.env.VITE_APPLE_CLIENTID ? "✓" : "✗ MISSING",
      });
      // ───────────────────────────────────────────────────────────
      switch (snsType) {
        case "google":
          setSns("SNS_TYPE_GOOGLE");
          if (isAndroid) {
            console.log("[LOGIN-GOOGLE] → Android 네이티브 브릿지 호출", { mungObj: !!window.mung });
            window.mung.nativeLogin("google");
          } else if (isIOS) {
            console.log("[LOGIN-GOOGLE] → iOS WebKit 메시지 호출", { webkit: !!window.webkit?.messageHandlers?.mung });
            array.push("google");
            window.webkit?.messageHandlers?.mung?.postMessage(array);
          } else {
            const url = buildAuthUrlWithPrompt(GOOGLE_AUTH_URL, "google");
            console.log("[LOGIN-GOOGLE] → 웹 OAuth URL 이동", { url });
            href(url);
          }
          break;
        case "naver":
          setSns("SNS_TYPE_NAVER");
          if (isAndroid) {
            console.log("[LOGIN-NAVER] → Android 네이티브 브릿지");
            window.mung.nativeLogin("naver");
          } else if (isIOS) {
            console.log("[LOGIN-NAVER] → iOS WebKit 메시지");
            array.push("naver");
            window.webkit?.messageHandlers?.mung?.postMessage(array);
          } else {
            const url = buildAuthUrlWithPrompt(NAVER_AUTH_URL, "naver");
            console.log("[LOGIN-NAVER] → 웹 OAuth URL 이동", { url });
            href(url);
          }
          break;
        case "kakao":
          if (isAndroid) {
            console.log("[LOGIN-KAKAO] → Android 네이티브 브릿지");
            window.mung.nativeLogin("kakao");
          } else if (isIOS) {
            console.log("[LOGIN-KAKAO] → iOS WebKit 메시지");
            array.push("kakao");
            window.webkit?.messageHandlers?.mung?.postMessage(array);
          } else {
            // 웹(PC/모바일웹): 풀 redirect (표준 OAuth)
            const url = buildAuthUrlWithPrompt(KAKAO_AUTH_URL, "kakao");
            console.log("[LOGIN-KAKAO] → 웹 풀 redirect", { url });
            href(url);
          }
          setSns("SNS_TYPE_KAKAO");
          break;
        case "apple":
          if (isAndroid) {
            console.log("[LOGIN-APPLE] → Android 네이티브 브릿지");
            window.mung.nativeLogin("apple");
          } else if (isIOS) {
            console.log("[LOGIN-APPLE] → iOS WebKit 메시지");
            array.push("apple");
            window.webkit?.messageHandlers?.mung?.postMessage(array);
          } else {
            // 웹: JS SDK 팝업 방식.
            // 애플은 response_mode 가 form_post 라 다른 SNS 처럼 /oauth/apple 로
            // 풀 redirect 를 받을 수 없다(정적 라우트는 POST 를 못 받고, 백엔드에도
            // 그 콜백을 받는 엔드포인트가 없어 404 로 끝났다).
            console.log("[LOGIN-APPLE] → 웹 SDK 팝업", {
              clientId: import.meta.env.VITE_APPLE_CLIENTID,
              redirectUri: import.meta.env.VITE_APPLE_REDIRECT,
            });
            setSns("SNS_TYPE_APPLE");
            // ⚠️ await 하지 않는다 — 팝업은 클릭 태스크 안에서 열려야 차단되지 않는다
            loginWithApple();
          }
          break;
        default:
          throw new Error("sns type이 잘못되었습니다.");
      }
    },
    [
      setSns,
      add,
      // toggleLoading,
      isAndroid,
      isIOS,
      loginWithApple,
    ],
  );

  // const handleGoSignIn = useCallback(
  //   (business: BusinessType) => {
  //     if (business) {
  //       setBusiness(business);
  //       history.push(`/sign-up/${business}`);
  //     }
  //   },
  //   [history, sns]
  // );

  usePreload(
    visualImgSrc,
    visualBusinessImgSrc,
    appleImgSrc,
    googleImgSrc,
    kakaoImgSrc,
    naverImgSrc,
  );
  useAppColor({
    background: "#ff9934",
  });

  return (
    <div className="flex flex-col min-h-screen bg-yellow">
      <div className="flex-auto content-center m-auto w-fit">
        <img
          src={visualImg}
          alt="멍투데이"
          className="object-contain p-3 max-w-full max-h-96"
          onClick={handleImgClick}
        />
      </div>

      <div className="px-5 py-10 text-center bg-white rounded-t-3xl drop-shadow-2xl flex-0">
        <h1 className="mb-10 text-2xl font-medium">시작하기</h1>
        <div className="flex flex-col gap-4">
          <AnimatePresence>
            <>
              {showDevButtons && (
                <>
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Button
                      className="rounded-full !flex m-auto"
                      onClick={() => handleDummyLogin("owner", "SNS_TYPE_GOOGLE")}
                    >
                      사업자
                    </Button>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Button
                      className="rounded-full !flex m-auto"
                      onClick={() => handleDummyLogin("teacher1", "SNS_TYPE_GOOGLE")}
                    >
                      선생님1
                    </Button>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Button
                      className="rounded-full !flex m-auto"
                      onClick={() => handleDummyLogin("teacher2", "SNS_TYPE_GOOGLE")}
                    >
                      선생님2
                    </Button>
                  </motion.div>
                </>
              )}
              {/* 애플: Android 앱(MT_A)만 숨김. iOS 앱·iOS 웹·Android 웹·PC 모두 노출 */}
              {!isAppAndroid && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <Button
                    onClick={handleGoSignUp}
                    className="rounded-full !flex m-auto"
                    data-sns-type="apple"
                  >
                    <img src={appleImgSrc} alt="애플" />
                  </Button>
                </motion.div>
              )}
              {/* 구글: iOS 앱(MT_I)만 숨김 (App Store 정책). 그 외 모든 환경 노출 */}
              {!isAppIOS && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <Button
                    className="rounded-full !flex m-auto"
                    onClick={handleGoSignUp}
                    data-sns-type="google"
                  >
                    <img src={googleImgSrc} alt="구글" />
                  </Button>
                </motion.div>
              )}
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3 }}
              >
                <Button
                  className="rounded-full !flex m-auto"
                  onClick={handleGoSignUp}
                  data-sns-type="kakao"
                >
                  <img src={kakaoImgSrc} alt="카카오" />
                </Button>
              </motion.div>
              {/* {showLoginForm && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5 }}
                      className="mt-6 space-y-4"
                    >
                      <div className="space-y-3">
                        <div>
                          <label className="block mb-1 text-sm font-medium text-gray-700">
                            아이디
                          </label>
                          <Input
                            type="text"
                            value={userId}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => setUserId(e.target.value)}
                            onKeyPress={handleKeyPress}
                            placeholder="아이디를 입력하세요"
                            className="w-full"
                          />
                        </div>

                        <div>
                          <label className="block mb-1 text-sm font-medium text-gray-700">
                            비밀번호
                          </label>
                          <Input
                            type="password"
                            value={password}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => setPassword(e.target.value)}
                            onKeyPress={handleKeyPress}
                            placeholder="비밀번호를 입력하세요"
                            className="w-full"
                          />
                        </div>

                        {errorMessage && (
                          <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            className="text-sm text-center text-red-500"
                          >
                            {errorMessage}
                          </motion.div>
                        )}

                        <ThemedButton
                          color="primary"
                          size="xl"
                          className="w-full"
                          onClick={handleLogin}
                          disabled={isLoading}
                        >
                          {isLoading ? "로그인 중..." : "로그인"}
                        </ThemedButton>
                      </div>
                    </motion.div>
                  )} */}
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3 }}
              >
                <Button
                  className="rounded-full !flex m-auto"
                  onClick={handleGoSignUp}
                  data-sns-type="naver"
                >
                  <img src={naverImgSrc} alt="네이버" />
                </Button>
              </motion.div>
            </>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
